<template>
  <div class="h-100">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading">
          <div class="d-flex justify-content-start align-items-center mb-3">
            <b-btn
              class="mr-1"
              size="sm"
              variant="secondary"
              @click="exportDevice"
            >
              <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
              Exportovať
            </b-btn>
            <b-btn
              v-if="$root.user.isAdmin"
              class="text-uppercase"
              size="sm"
              variant="primary"
              @click="add({ type: type })"
            >
              <b-icon class="mr-1" icon="plus" scale="1.5x" />
              Pridať
            </b-btn>
          </div>
          <div v-if="!data.length" class="nodata-container">
            <div class="text-center my-3">
              <div class="mb-3">
                <b-icon font-scale="5" icon="question-diamond" />
              </div>
              <h2 class="mb-3">Žiadne dáta</h2>
            </div>
          </div>
          <template v-else>
            <component
              :is="type + 'View'"
              v-if="type"
              :data="data"
              :energetic="energetic"
            />
          </template>
        </div>
      </transition>
    </b-overlay>
    <add-device ref="deviceForm" />
  </div>
</template>
<script>
import AddDevice from './Add'
import PowerView from './power/View'
import { mapState } from 'vuex'

export default {
  components: {
    AddDevice,
    PowerView,
  },
  data() {
    return {
      loading: false,
      data: [],
      type: null,
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.$root.$on('reloadEnergeticDeviceData', this.fetchData)
    this.type = this.$store.getters['energetic/getCurrentType']
  },
  beforeDestroy: function () {
    this.$root.$off('reloadEnergeticDeviceData')
  },
  methods: {
    add({ type, edit = false }) {
      this.$refs.deviceForm.type = type
      this.$refs.deviceForm.edit = edit
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-device')
      })
    },
    remove(id) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť tento prístroj?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api.post(`energetics/${id}/remove_device`).then((res) => {
            this.$swal({
              type: 'success',
              position: 'top',
              showCloseButton: true,
              text: res.data.message,
              timer: 5000,
            })
            this.fetchData()
          })
        }
      })
    },
    fetchData(silent = false) {
      this.loading = !silent
      this.$api
        .get(`energetics/${this.$route.params.energetics_id}/device/get_list`)
        .then((res) => {
          this.data = res.data.data
          if (!silent) {
            this.loading = false
          }
        })
    },
    exportDevice() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('energetics/device/export', {
          params: { id: this.$route.params.energetics_id },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(
            new Blob([res.data]),
            'pristroje_' +
              this.energetic[
                `${this.$store.getters['energetic/getCurrentType']}Number`
              ] +
              '.xlsx',
          )
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
